<script>
	import options from './ProductDetailImages.options'
	export default options
</script>

<template>
	<div class="nlx-product-detail-images__container">
		
		<div v-if="isMobile" class="glide glide--thumbnails nlx-product-detail-images__thumbnail-section">

			<!-- related images -->
			<section class="glide__track" data-glide-el="track">
				<ul class="glide__slides nlx-product-detail-images__thumbnail-container" :style="scrollDistanceStyle" :class="imageData.length < 3 ? 'nlx-product-detail-images__thumbnail-container--border-bottom' : ''">
					<template v-for="(image,index) in imageData" :key="index">
						<li tabindex="0" @click="selectImage($event, index)" @keyup.stop="selectImage($event, index)" class="glide__slide nlx-product-detail-images__thumbnail-image" :class="image.isSelected ? 'nlx-product-detail-images__thumbnail-image--selected' : ''">

							<picture>
								<source class="nlx-js-srcset-identifier-1" :srcset="image.ssrcsetUrlMedium" media="(min-width: 768px)">
								<source class="nlx-js-srcset-identifier-2" :srcset="image.srcsetUrlSmall" media="(min-width: 300px)">
								<img :src="image.primaryUrl" :alt="image.alt">	
							</picture>

						</li>
					</template>
				</ul>
			</section>


			<section class="nlx-product-detail-images__slider-section-detail glide__bullets" data-glide-el="controls[nav]">  
				<template v-for="(imageBullet, index) in imageData" :key="index">
					<button class="glide__bullet" :data-glide-dir="`=${index}`"></button>
				</template>
			</section>
		</div>

		<section v-else class="nlx-product-detail-images__thumbnail-section">
			<template v-if="showScrollUpButton">
				<button class="nlx-product-detail-images__scroll-up-button" @click="scrollThumbnailsUp">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#ffffff" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>
				</button>
			</template>
			<ul class="nlx-product-detail-images__thumbnail-container" :style="scrollDistanceStyle" :class="imageData.length < 3 ? 'nlx-product-detail-images__thumbnail-container--border-bottom' : ''">
				<template v-for="(image,index) in imageData" :key="index">
					<li tabindex="0" @click="selectImage($event, index)" @keyup.stop="selectImage($event, index)" class="nlx-product-detail-images__thumbnail-image" :class="image.isSelected ? 'nlx-product-detail-images__thumbnail-image--selected' : ''">

						<picture>
							<source class="nlx-js-srcset-identifier-1" :srcset="image.ssrcsetUrlMedium" media="(min-width: 768px)">
							<source class="nlx-js-srcset-identifier-2" :srcset="image.srcsetUrlSmall" media="(min-width: 300px)">
							<img :src="image.primaryUrl" :alt="image.alt">	
						</picture>

					</li>
					</template>
				</ul>
			<template v-if="showScrollDownButton">
				<button class="nlx-product-detail-images__scroll-down-button" @click="scrollThumbnailsDown">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#ffffff" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>
				</button>
			</template>
		</section>

		<section class="glide glide--primary nlx-product-detail-images__primary-image-section">

			<div class="glide__track" data-glide-el="track">
				<ul class="glide__slides">

					<template v-for="(image,index) in imageData" :key="index">
						<li class="glide__slide" @click="inspectImage(index)" @touchstart="selectImage($event, index)">
							<div class="nlx-product-detail-images__label-container">
								<template v-for="(label, labelIndex) in productLabels" :key="labelIndex">
									<span class="nlx-product-detail-images__label" :style="{ backgroundColor: label.colorCode}">{{label.value}}</span>
								</template>
							</div>
							<div :aria-label="image.alt" role="img" class="nlx-product-detail-images__primary-image" :style='`background-image: url(${image.primaryUrl})`'></div>
						</li>
					</template>

				</ul>
			</div>

			<div class="nlx-product-detail-images__slider-section glide__bullets" data-glide-el="controls[nav]">    
				<template v-for="(imageBullet, index) in imageData" :key="index">
					<button class="glide__bullet" :data-glide-dir="`=${index}`"></button>
				</template>
			</div>

		</section>

		<div class="nlx-product-detail-images__modal" v-if="modalActiveState" @click.self="closeModal">
			<div class="nlx-product-detail-images__modal-content">
				<button @click="closeModal" class="nlx-product-detail-images__close-modal">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
				</button>
				<img class="nlx-product-detail-images__modal-image" :src="imageSelectedForModal.url" :alt="imageSelectedForModal.alt">
			</div>
		</div>

	</div>
</template>
